import type { WebInteractClickParams } from '@squareup/customer-data-events-web'

/**
 * Defines the user actions logged to RUM for the support/help apps.
 * Used for CD monitoring.
 */
export enum SupportAction {
  // Page Load Actions
  HomeLoaded = 'Support Home Loaded',
  ArticleLoaded = 'Article Loaded',
  ArticleNotFound = 'Article Not Found',
  SearchResultsLoaded = 'Search Results Loaded',
  SearchFailed = 'Search Failed',

  // Contact Actions
  StartChatClicked = 'Start Chat Clicked',
  CallPhoneClicked = 'Call Phone Clicked',
  RequestCallStarted = 'Request Call Started',
  RequestCallCompleted = 'Request Call Completed',

  // Error Actions
  ErrorPageShown = 'Error Page Shown',
}

export const eventActionType = {
  LINK_CLICK: 'LINK_CLICK',
  OPEN_MODAL: 'OPEN_MODAL',
  BLOCKER_ACTION: 'BLOCKER_ACTION',
}

export const getElementEventData = (
  element: EventTarget & HTMLAnchorElement,
  actionType = eventActionType.LINK_CLICK
): WebInteractClickParams => {
  return {
    pageName: element.text || element.href,
    componentName: element.tagName,
    componentType: actionType,
  }
}
